module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Pistache.f354c361.pdf";